<template>
  <Skeleton :height="height" />
</template>

<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';

defineProps({
  height: {
    type: String,
    default: '114px',
  },
});
</script>
